import React, { useRef, useEffect } from "react"

import Torus from "./components/Torus"
import { Motion } from "./components/Motion"
import { MiniMap } from "./components/MiniMap"

const MOVE_THRESHOLD = 15

const App = () => {
  const torusRef = useRef()

  useEffect(() => {
    try {
      window.screen.orientation.lock("portrait-primary")
    } catch (e) {
      console.log(e)
    }
  }, [])

  return (
    <div style={{ position: "relative" }}>
      <Torus ref={torusRef} />
      <Motion
        onChangeOrientation={({ gamma, beta }) => {
          if (torusRef.current) {
            const magBeta = Math.abs(beta)
            if (magBeta > MOVE_THRESHOLD / 2) {
              const dirBeta = beta >= 0 ? 1 : -1
              torusRef.current.speedPhi = dirBeta * -0.003 * magBeta
            }

            const magGamma = Math.abs(gamma)
            if (magGamma > MOVE_THRESHOLD) {
              const dirGamma = gamma >= 0 ? 1 : -1
              torusRef.current.speedTheta = dirGamma * 0.0007 * magGamma
            }
          }
        }}
      />
      <div style={{ marginTop: 30, position: "absolute" }}>
        <div style={{ margin: 2, color: "#fff" }}>
          theta{torusRef.current ? torusRef.current.speedTheta : "?"}
        </div>
        <div style={{ margin: 2, color: "#fff" }}>
          phi{torusRef.current ? torusRef.current.speedPhi : "?"}
        </div>
      </div>
      <MiniMap torusRef={torusRef} />
    </div>
  )
}

export default App
